import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import styles from './Carousel.module.scss';
const ChevronRight = (props) => (
  <svg
    viewBox='0 0 24 24'
    width='18'
    height='18'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    {...props}
  >
    <path d='M9 6l6 6-6 6' />
  </svg>
);

const ChevronLeft = (props) => (
  <svg
    viewBox='0 0 24 24'
    width='18'
    height='18'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    {...props}
  >
    <path d='M15 6l-6 6 6 6' />
  </svg>
);
const Carousel = ({ data, isLoading, activeApplication }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: false,
    beforeChange: (_, newIndex) => setCurrentSlide(newIndex),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => (
      <div>
        <ul className={styles.dots} style={{ listStyle: 'none' }}>
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <button
        key={i}
        className={`${styles.dotButton} ${
          currentSlide === i ? styles.slickActive : ''
        }`}
      ></button>
    ),
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const activeIndex = data.findIndex(
        (app) => app.id === activeApplication?.id
      );
      if (activeIndex >= 0 && activeIndex !== currentSlide) {
        sliderRef.current?.slickGoTo(activeIndex);
      }
    }
  }, [activeApplication, data, currentSlide]);
  return (
    <div className={styles['slider-wrapper']}>
      <div className={styles['slider-container']}>
        <Slider {...settings} ref={sliderRef}>
          {data?.map((app, index) => (
            <div key={index} className={styles['card-container']}>
              <div key={index} className={styles['card']}>
                {isLoading ? (
                  <div className={styles['loading-placeholder']}>
                    Loading...
                  </div>
                ) : (
                  <>
                    <img
                      src={app.blobUrl}
                      alt={`Slide ${index}`}
                      className={styles['image']}
                    />
                    <h3 className={styles['title']}>{app.cardTitle}</h3>

                    <h3 className={styles['text']}>{app.cardDescription}</h3>
                  </>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

const NextArrow = ({ onClick }) => {
  return (
    <button className={`${styles.arrow} ${styles.next}`} onClick={onClick}>
      <ChevronRight />
    </button>
  );
};

const PrevArrow = ({ onClick }) => {
  return (
    <button className={`${styles.arrow} ${styles.prev}`} onClick={onClick}>
      <ChevronLeft />
    </button>
  );
};

export default Carousel;
